<mat-card class="card">
  <mat-card-header>
    <h4 mat-card-title>{{ 'Unassigned Disks' | translate }}</h4>
  </mat-card-header>

  <mat-card-content>
    <h1 class="value">{{ unusedDisks.length }}</h1>
    <button
      mat-button
      ixTest="add-to-pool"
      [disabled]="!unusedDisks.length"
      (click)="onAddToStorage()"
    >{{ 'Add To Pool' | translate }}</button>
  </mat-card-content>
</mat-card>
